import classNames from 'classnames';
import { Heading, Paragraph } from 'ui/components';
import styles from './ConsentPlaceholder.module.scss';

export interface ConsentPlaceholderProps {
	className?: string;
	heading: string;
	text: string;
	fillContainer?: boolean;
}

export const ConsentPlaceholder: React.FC<ConsentPlaceholderProps> = ({ className, heading, text, fillContainer = false }) => {
	return (
		<div className={classNames(styles.ConsentPlaceholder, { [styles.ConsentPlaceholder___fillContainer]: fillContainer }, className)}>
			<Heading headingLevel="h3" style="xs" className={styles.ConsentPlaceholder_heading}>
				{heading}
			</Heading>
			<Paragraph style="sm" className={styles.ConsentPlaceholder_text}>
				{text}
			</Paragraph>
		</div>
	);
};
